import { render, staticRenderFns } from "./EditMatchResult.vue?vue&type=template&id=51b91524&scoped=true"
import script from "./EditMatchResult.vue?vue&type=script&lang=js"
export * from "./EditMatchResult.vue?vue&type=script&lang=js"
import style0 from "./EditMatchResult.vue?vue&type=style&index=0&id=51b91524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b91524",
  null
  
)

export default component.exports